var D = Object.defineProperty;
var x = (e, t, n) => t in e ? D(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var c = (e, t, n) => x(e, typeof t != "symbol" ? t + "" : t, n);
import { isValid as l, parse as I, format as T } from "date-fns";
import { it as F, fr as H, de as W, es as b, enUS as y } from "date-fns/locale";
import { useState as U, useCallback as $, useEffect as z } from "react";
import { z as o } from "zod";
import { AuthError as V } from "@aws-amplify/auth";
import * as r from "@sentry/react";
import { Amplify as k } from "aws-amplify";
function f() {
  return "dev.gcheckin.com";
}
function he(e) {
  if (!e)
    throw new Error("formAppUrl: publicId is required");
  return `https://${f()}/f/${e}`;
}
function fe(e) {
  if (!e)
    throw new Error("listingCheckinUrl: listingPublicId is required");
  return `https://${f()}/l/${e}`;
}
const G = /^[a-z0-9-]{3,40}$/;
function Ee(e, t) {
  if (!e)
    throw new Error("formAppUrlBranded: publicId must be a non-empty string");
  const n = f();
  if (t && t.isActive && t.slug) {
    const i = t.slug.trim();
    if (i !== "" && G.test(i))
      return `https://${i}.${n}/f/${e}`;
  }
  return `https://${n}/f/${e}`;
}
const B = /^[a-z0-9-]{3,40}$/;
function ge(e, t) {
  if (!e)
    throw new Error("listingAppUrlBranded: listingPublicId must be a non-empty string");
  const n = f();
  if (t && t.isActive && t.slug) {
    const i = t.slug.trim();
    if (i !== "" && B.test(i))
      return `https://${i}.${n}/l/${e}`;
  }
  return `https://${n}/l/${e}`;
}
const Y = 4.5;
function Ie(e, t) {
  const n = C(e), i = C(t), s = P(n[0], n[1], n[2]), a = P(i[0], i[1], i[2]), h = Math.max(s, a), g = Math.min(s, a), L = (h + 0.05) / (g + 0.05), A = Math.round(L * 10) / 10;
  return { pass: A >= Y, roundedRatio: A };
}
function P(e, t, n) {
  const i = p(e), s = p(t), a = p(n);
  return 0.2126 * i + 0.7152 * s + 0.0722 * a;
}
function p(e) {
  const t = e / 255;
  return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function C(e) {
  if (e == null)
    throw new Error("hex color is null/undefined");
  const t = e.startsWith("#") ? e.slice(1) : e;
  if (t.length !== 6 && t.length !== 8)
    throw new Error(`hex color must be 6 or 8 digits after '#': got ${e}`);
  if (!/^[0-9a-fA-F]{6,8}$/.test(t))
    throw new Error(`hex color contains non-hex characters: ${e}`);
  const n = parseInt(t.substring(0, 2), 16), i = parseInt(t.substring(2, 4), 16), s = parseInt(t.substring(4, 6), 16);
  return [n, i, s];
}
function R(e) {
  const t = e.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (t) {
    const [, n, i, s] = t;
    return new Date(parseInt(n, 10), parseInt(i, 10) - 1, parseInt(s, 10));
  }
  return new Date(e);
}
const d = {
  API: "yyyy-MM-dd",
  DISPLAY: "yyyy-MM-dd"
}, pe = {
  // Convert from display format to API format
  toAPIFormat(e) {
    if (!e) return "";
    if (e.match(/^\d{4}-\d{2}-\d{2}$/)) return e;
    const t = I(e, d.DISPLAY, /* @__PURE__ */ new Date());
    return l(t) ? T(t, d.API) : "";
  },
  // Convert from API format to display format
  toDisplayFormat(e) {
    if (!e) return "";
    if (e.match(/^\d{2}\.\d{2}\.\d{4}$/)) return e;
    const t = R(e);
    return l(t) ? T(t, d.DISPLAY) : "";
  },
  // Validate date string in display format
  isValidDisplayDate(e) {
    if (!e) return !1;
    const t = I(e, d.DISPLAY, /* @__PURE__ */ new Date());
    return l(t) && t <= /* @__PURE__ */ new Date();
  },
  // Parse any format to Date object
  parseAnyFormat(e) {
    if (!e) return null;
    let t = R(e);
    return l(t) ? t : (t = I(e, d.DISPLAY, /* @__PURE__ */ new Date()), l(t) ? t : null);
  }
};
var q = /* @__PURE__ */ ((e) => (e.IMAGE = "IMAGE", e.PDF = "PDF", e.EXTERNAL_URL = "EXTERNAL_URL", e.UNKNOWN = "UNKNOWN", e))(q || {});
const N = (e) => {
  if (!e) return "UNKNOWN";
  switch (e) {
    case "IMAGE":
      return "IMAGE";
    case "PDF":
      return "PDF";
    case "EXTERNAL_URL":
      return "EXTERNAL_URL";
    default:
      return "UNKNOWN";
  }
};
function _e(e) {
  return N(e) === "IMAGE";
}
function Se(e) {
  return N(e) === "PDF";
}
function we(e) {
  return N(e) === "EXTERNAL_URL";
}
const M = "preferred_dashboard_view", Ne = () => localStorage.getItem(M) || "listings", Ae = (e) => {
  localStorage.setItem(M, e);
};
class K {
  constructor() {
    c(this, "notificationAudio", null);
    c(this, "isInitialized", !1);
    c(this, "audioUnlocked", !1);
  }
  /**
   * Initialize the audio element
   * Should be called after user interaction to comply with browser autoplay policies
   */
  initialize() {
    if (!this.isInitialized)
      try {
        this.notificationAudio = new Audio("/notification.wav"), this.notificationAudio.volume = 1, this.notificationAudio.preload = "auto", this.notificationAudio.load(), this.isInitialized = !0, console.debug("Sound manager initialized");
      } catch (t) {
        console.error("Failed to initialize sound manager:", t);
      }
  }
  /**
   * Register a one-time listener that unlocks audio on the user's first
   * interaction (click, tap, or key press). Browsers require a user gesture
   * before Audio.play() is allowed.
   */
  initAudioUnlock() {
    const t = ["pointerdown", "keydown"], n = () => {
      this.unlockAudio(), t.forEach((i) => document.removeEventListener(i, n));
    };
    t.forEach((i) => document.addEventListener(i, n, { once: !1 }));
  }
  unlockAudio() {
    if (this.audioUnlocked || (this.isInitialized || this.initialize(), !this.notificationAudio)) return;
    const t = this.notificationAudio.volume;
    this.notificationAudio.volume = 0, this.notificationAudio.play().then(() => {
      this.notificationAudio.pause(), this.notificationAudio.currentTime = 0, this.notificationAudio.volume = t, this.audioUnlocked = !0, console.debug("Sound manager audio unlocked");
    }).catch(() => {
      this.notificationAudio.volume = t;
    });
  }
  /**
   * Play the notification sound
   * Works even when tab is in background by using a persistent audio element
   * @returns Promise that resolves when sound starts playing
   */
  async playNotification() {
    try {
      if (this.isInitialized || this.initialize(), !this.notificationAudio)
        throw new Error("Audio element not initialized");
      this.notificationAudio.currentTime = 0, await this.notificationAudio.play(), console.debug("Notification sound played");
    } catch (t) {
      console.warn("Failed to play notification sound:", t);
    }
  }
  /**
   * Set the volume for notification sounds
   * @param volume - Volume level between 0 and 1
   */
  setVolume(t) {
    this.notificationAudio && (this.notificationAudio.volume = Math.max(0, Math.min(1, t)));
  }
  /**
   * Check if sound is initialized
   */
  isReady() {
    return this.isInitialized;
  }
}
const m = new K(), Te = {
  playNotification: () => m.playNotification(),
  initialize: () => m.initialize(),
  initAudioUnlock: () => m.initAudioUnlock(),
  setVolume: (e) => m.setVolume(e),
  isReady: () => m.isReady()
};
function E(e) {
  try {
    return typeof window > "u" ? null : e === "local" ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}
function Pe(e) {
  const t = E(e);
  if (!t) return !1;
  const n = "__guardian_storage_probe__";
  try {
    return t.setItem(n, "1"), t.removeItem(n), !0;
  } catch {
    return !1;
  }
}
function X(e, t) {
  const n = E(e);
  if (!n) return null;
  try {
    return n.getItem(t);
  } catch {
    return null;
  }
}
function j(e, t, n) {
  const i = E(e);
  if (!i) return !1;
  try {
    return n === null ? (i.removeItem(t), !0) : (i.getItem(t) !== n && i.setItem(t, n), !0);
  } catch {
    return !1;
  }
}
function Ce(e, t) {
  const n = E(e);
  if (n)
    try {
      n.removeItem(t);
    } catch {
    }
}
function Re(e, t, n) {
  const i = X(e, t);
  if (i === null) return null;
  let s;
  try {
    s = JSON.parse(i);
  } catch {
    return null;
  }
  return n ? n(s) ? s : null : s;
}
function Oe(e, t, n) {
  let i;
  try {
    i = JSON.stringify(n);
  } catch {
    return !1;
  }
  return j(e, t, i);
}
const ye = (e) => {
  const t = document.getElementById(e);
  if (t) {
    const n = document.querySelector("header"), i = n ? n.offsetHeight : 0, a = t.getBoundingClientRect().top + window.pageYOffset - i;
    window.scrollTo({
      top: a,
      behavior: "smooth"
    });
  }
}, Ue = {
  h1: {
    size: "75px",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    fontWeight: 700
  },
  h2: {
    size: "60px",
    lineHeight: "1.2",
    letterSpacing: "-0.02em",
    fontWeight: 700
  },
  h3: {
    size: "45px",
    lineHeight: "1.2",
    letterSpacing: "-0.01em",
    fontWeight: 700
  },
  h4: {
    size: "30px",
    lineHeight: "1.2",
    fontWeight: 700
  },
  body: {
    size: "16px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  bodyLarge: {
    size: "18px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  bodySmall: {
    size: "14px",
    lineHeight: "1.5",
    fontWeight: 400
  },
  caption: {
    size: "12px",
    lineHeight: "1.5",
    fontWeight: 400
  }
}, J = {
  en: y,
  es: b,
  de: W,
  fr: H,
  it: F
};
function Me(e) {
  const t = (e || navigator.language).split("-")[0] ?? "en";
  return J[t] ?? y;
}
const ve = "guardian_device_trust", Le = "cognitoDeviceKey", De = {
  USER_SRP_AUTH: "USER_SRP_AUTH",
  USER_PASSWORD_AUTH: "USER_PASSWORD_AUTH",
  // Note: Disables device tracking
  CUSTOM_WITH_SRP: "CUSTOM_WITH_SRP",
  CUSTOM_WITHOUT_SRP: "CUSTOM_WITHOUT_SRP",
  USER_AUTH: "USER_AUTH"
}, S = {
  minLength: 8,
  requireUppercase: !0,
  requireLowercase: !0,
  requireNumbers: !0,
  requireSpecialChars: !1
}, xe = {
  INVALID_CREDENTIALS: "InvalidCredentialsException",
  USER_NOT_CONFIRMED: "UserNotConfirmedException",
  USER_NOT_FOUND: "UserNotFoundException",
  USERNAME_EXISTS: "UsernameExistsException",
  CODE_MISMATCH: "CodeMismatchException",
  EXPIRED_CODE: "ExpiredCodeException",
  LIMIT_EXCEEDED: "LimitExceededException",
  SESSION_EXPIRED: "SessionExpiredException",
  INVALID_PARAMETER: "InvalidParameterException",
  TOO_MANY_REQUESTS: "TooManyRequestsException"
}, Q = {
  NotAuthorizedException: "Invalid email or password",
  UserNotConfirmedException: "Please verify your email address",
  UserNotFoundException: "No account found with this email",
  UsernameExistsException: "An account with this email already exists",
  CodeMismatchException: "Invalid verification code",
  ExpiredCodeException: "Verification code has expired",
  LimitExceededException: "Too many attempts. Please try again later",
  InvalidPasswordException: "Password does not meet requirements",
  InvalidParameterException: "Invalid parameters provided",
  TooManyRequestsException: "Too many requests. Please try again later"
}, Fe = {
  // Email MFA challenges
  EMAIL_CODE: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
  EMAIL_OTP: "EMAIL_OTP",
  EMAIL_CUSTOM: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  // SMS MFA challenges
  SMS: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  SMS_CODE: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  // TOTP MFA challenges
  TOTP: "CONFIRM_SIGN_IN_WITH_TOTP_CODE",
  TOTP_MFA: "CONFIRM_SIGN_IN_WITH_TOTP_MFA_CODE",
  SOFTWARE_TOKEN: "CONFIRM_SIGN_IN_WITH_SOFTWARE_TOKEN_MFA_CODE",
  // New password required
  NEW_PASSWORD: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  // Custom challenges
  CUSTOM_CHALLENGE: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  // MFA selection
  MFA_SELECTION: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
  MFA_SETUP_SELECTION: "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION",
  // TOTP setup
  TOTP_SETUP: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
  EMAIL_SETUP: "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP"
}, He = "trusted_device_status", We = "mfa_session_data", be = 6, $e = 5, ze = 30, Ve = 3, ke = 30, Ge = () => {
  const [e, t] = U({
    isValid: !1,
    hasMinLength: !1,
    hasUppercase: !1,
    hasLowercase: !1,
    hasNumber: !1,
    hasSpecialChar: !1,
    score: 0
  }), n = $((i) => {
    const s = {
      hasMinLength: i.length >= S.minLength,
      hasUppercase: /[A-Z]/.test(i),
      hasLowercase: /[a-z]/.test(i),
      hasNumber: /\d/.test(i),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(i),
      score: 0,
      isValid: !1
    };
    let a = 0;
    return Object.entries(s).forEach(([h, g]) => {
      h !== "score" && h !== "isValid" && g && (a += 20);
    }), s.score = a, s.isValid = a >= 60, t(s), s;
  }, []);
  return {
    strength: e,
    validatePassword: n
  };
};
function Z(e) {
  return typeof window > "u" ? !1 : window.matchMedia(e).matches;
}
function Be(e) {
  const [t, n] = U(() => Z(e));
  return z(() => {
    const i = window.matchMedia(e);
    n(i.matches);
    const s = () => n(i.matches);
    return i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, [e]), t;
}
const v = o.string().min(S.minLength, {
  message: `Password must be at least ${S.minLength} characters`
}).regex(/[a-z]/, {
  message: "Password must contain at least one lowercase letter"
}).regex(/[A-Z]/, {
  message: "Password must contain at least one uppercase letter"
}).regex(/\d/, { message: "Password must contain at least one number" }), Ye = o.object({
  email: o.string().email({ message: "Invalid email address" }),
  password: v,
  confirmPassword: o.string(),
  firstName: o.string().min(2, { message: "First name must be at least 2 characters" }),
  lastName: o.string().min(2, { message: "Last name must be at least 2 characters" })
}).refine((e) => e.password === e.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
}), qe = o.object({
  email: o.string().email({ message: "Invalid email address" }),
  password: o.string().min(1, { message: "Password is required" })
}), Ke = o.object({
  email: o.string().email({ message: "Invalid email address" })
}), Xe = o.object({
  code: o.string().min(1, "Verification code is required"),
  newPassword: o.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: o.string()
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords must match",
  path: ["confirmPassword"]
}), je = o.object({
  code: o.string().min(6, { message: "Invalid confirmation code" })
}), Je = o.object({
  currentPassword: o.string().min(1, "Current password is required"),
  newPassword: o.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number"),
  confirmPassword: o.string().min(1, "Please confirm your password")
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords do not match",
  path: ["confirmPassword"]
}), Qe = o.object({
  newPassword: v,
  confirmPassword: o.string()
}).refine((e) => e.newPassword === e.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
});
class O extends Error {
  constructor(t, n, i) {
    super(n), this.code = t, this.message = n, this.originalError = i, this.name = "AuthenticationError";
  }
}
const Ze = (e) => {
  if (e instanceof V) {
    const t = Q[e.name] || e.message;
    return new O(e.name, t, e);
  }
  return new O(
    "UnknownError",
    "An unexpected authentication error occurred",
    e instanceof Error ? e : void 0
  );
}, et = {
  save(e) {
    localStorage.setItem("unconfirmedAccount", e);
  },
  get() {
    return localStorage.getItem("unconfirmedAccount");
  },
  clear() {
    localStorage.removeItem("unconfirmedAccount");
  }
};
var ee = /* @__PURE__ */ ((e) => (e.LOW = "low", e.MEDIUM = "medium", e.HIGH = "high", e.CRITICAL = "critical", e))(ee || {}), te = /* @__PURE__ */ ((e) => (e.NETWORK = "network", e.AUTH = "auth", e.VALIDATION = "validation", e.SERVER = "server", e.TIMEOUT = "timeout", e.RATE_LIMIT = "rate_limit", e.NOT_FOUND = "not_found", e.PERMISSION = "permission", e))(te || {});
class _ {
  static classify(t, n) {
    const i = {
      category: "network",
      severity: "medium",
      isRetryable: !0,
      shouldShowToast: !0,
      originalError: t,
      endpoint: n
    };
    return this.isAxiosError(t) ? this.classifyAxiosError(t, i) : t instanceof Error ? this.classifyByErrorMessage(t, i) : i;
  }
  static classifyByErrorMessage(t, n) {
    const i = t.message.toLowerCase();
    return i.includes("failed to fetch") || i.includes("network error") || i.includes("connection refused") ? {
      ...n,
      category: "network",
      severity: this.getNetworkErrorSeverity(n.endpoint),
      isRetryable: !0,
      shouldShowToast: this.shouldShowNetworkToast(n.endpoint),
      userMessage: this.getNetworkErrorMessage(n.endpoint)
    } : i.includes("timeout") || i.includes("abort") ? {
      ...n,
      category: "timeout",
      severity: this.getTimeoutSeverity(n.endpoint),
      isRetryable: !0,
      shouldShowToast: !this.isNonCriticalEndpoint(n.endpoint)
    } : n;
  }
  static classifyAxiosError(t, n) {
    var s;
    const i = (s = t.response) == null ? void 0 : s.status;
    if (!i)
      return {
        ...n,
        category: "network",
        severity: this.getNetworkErrorSeverity(n.endpoint),
        isRetryable: !0,
        shouldShowToast: this.shouldShowNetworkToast(n.endpoint)
      };
    switch (!0) {
      case i === 401:
        return {
          ...n,
          category: "auth",
          severity: "high",
          isRetryable: !1,
          shouldShowToast: !1
          // Handle auth errors separately
        };
      case i === 403:
        return {
          ...n,
          category: "permission",
          severity: "medium",
          isRetryable: !1,
          // Don't show toast for permission-sensitive endpoints (user likely lacks permission)
          shouldShowToast: !this.isPermissionSensitiveEndpoint(n.endpoint)
        };
      case i === 404:
        return {
          ...n,
          category: "not_found",
          severity: this.isNonCriticalEndpoint(n.endpoint) ? "low" : "medium",
          isRetryable: !1,
          shouldShowToast: !this.isNonCriticalEndpoint(n.endpoint)
        };
      case i === 429:
        return {
          ...n,
          category: "rate_limit",
          severity: "medium",
          isRetryable: !0,
          shouldShowToast: !0
        };
      case (i >= 400 && i < 500):
        return {
          ...n,
          category: "validation",
          severity: "medium",
          isRetryable: !1,
          // Don't show toast for permission-sensitive endpoints on 400 errors (likely permission issues)
          shouldShowToast: !this.isPermissionSensitiveEndpoint(n.endpoint)
        };
      case i >= 500:
        return {
          ...n,
          category: "server",
          severity: this.isCriticalEndpoint(n.endpoint) ? "high" : "medium",
          isRetryable: !0,
          shouldShowToast: !0
        };
      default:
        return n;
    }
  }
  static isAxiosError(t) {
    return (t == null ? void 0 : t.isAxiosError) === !0;
  }
  static isNonCriticalEndpoint(t) {
    return t ? this.NON_CRITICAL_ENDPOINTS.some((n) => t.includes(n)) : !1;
  }
  static isCriticalEndpoint(t) {
    return t ? this.CRITICAL_ENDPOINTS.some((n) => t.includes(n)) : !1;
  }
  static isPermissionSensitiveEndpoint(t) {
    return t ? this.PERMISSION_SENSITIVE_ENDPOINTS.some((n) => t.includes(n)) : !1;
  }
  static getNetworkErrorSeverity(t) {
    return this.isCriticalEndpoint(t) ? "high" : this.isNonCriticalEndpoint(t) ? "low" : "medium";
  }
  static getTimeoutSeverity(t) {
    return this.isCriticalEndpoint(t) ? "high" : "low";
  }
  static shouldShowNetworkToast(t) {
    return !this.isNonCriticalEndpoint(t);
  }
  static getNetworkErrorMessage(t) {
    return this.isNonCriticalEndpoint(t) ? "Some features may not be up to date" : "Connection issue detected. Please check your internet connection.";
  }
}
c(_, "NON_CRITICAL_ENDPOINTS", [
  "/activities/unread/count",
  "/notifications/count",
  "/stats/summary",
  "/health",
  "/ping"
]), c(_, "CRITICAL_ENDPOINTS", [
  "/auth/",
  "/profile",
  "/users/me"
]), // Endpoints that should suppress toast errors on 400/403 (permission issues)
c(_, "PERMISSION_SENSITIVE_ENDPOINTS", [
  "/calendar/form-present-between-dates",
  "/forms/calendar",
  "/listings",
  "/forms"
]);
class ne extends Error {
  constructor(t = "Failed to connect to the server") {
    super(t), this.name = "ConnectionError";
  }
}
const ie = (e) => e instanceof Error ? e.message.includes("Failed to fetch") || e.message.includes("Network Error") || e.message.includes("CONNECTION_REFUSED") || e.message.includes("ECONNREFUSED") || e.message.toLowerCase().includes("network") || e.message.includes("timeout") || e.message.includes("abort") || e.message.includes("Failed to connect") || e.name && [
  "NetworkError",
  "AbortError",
  "TimeoutError",
  "ConnectionError"
].includes(e.name) || e instanceof ne : !1, tt = (e) => ({
  name: "CONNECTION_ERROR",
  code: 0,
  message: ie(e) ? e.message : "Failed to connect to the server",
  errorId: "CONN001"
}), nt = (e) => {
  if (!e) {
    r.setUser(null);
    return;
  }
  r.setUser({
    id: e.userId,
    // Consider hashing email or using a unique identifier instead
    email: e.email ? se(e.email) : void 0
  }), r.setContext("user_info", {
    role: e.role,
    hasEmail: !!e.email
  });
}, it = (e) => {
  r.setContext("form_context", {
    formId: e.formId,
    listingId: e.listingId,
    currentStep: e.step,
    totalSteps: e.totalSteps
  });
}, st = () => {
  r.setContext("form_context", null);
}, ot = (e, t) => {
  r.addBreadcrumb({
    category: "form",
    message: `Form step: ${e}`,
    level: "info",
    data: {
      step: e,
      ...t
    }
  });
}, rt = (e, t) => {
  r.addBreadcrumb({
    category: "navigation",
    message: `Navigated from ${e} to ${t}`,
    level: "info",
    data: { from: e, to: t }
  });
}, at = (e, t) => {
  r.addBreadcrumb({
    category: "auth",
    message: e,
    level: "info",
    data: t
  });
}, ct = (e, t, n, i) => {
  r.addBreadcrumb({
    category: "api",
    message: `${e} ${t}`,
    level: i ? "error" : "info",
    data: {
      method: e,
      url: t,
      status: n,
      error: i
    }
  });
}, ut = (e, t) => {
  r.addBreadcrumb({
    category: "user_action",
    message: e,
    level: "info",
    data: t
  });
}, lt = (e, t) => {
  r.addBreadcrumb({
    category: "validation",
    message: `Validation error on ${e}`,
    level: "warning",
    data: {
      field: e,
      error: t
    }
  });
}, dt = (e, t, n, i) => {
  r.addBreadcrumb({
    category: "file_upload",
    message: `File upload: ${e}`,
    level: i ? "info" : "error",
    data: {
      fileName: e,
      fileSize: t,
      fileType: n,
      success: i
    }
  });
}, mt = (e, t) => {
  t && r.setContext("error_context", t), r.captureException(e);
}, ht = (e, t = "info") => {
  r.captureMessage(e, t);
};
function se(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const i = e.charCodeAt(n);
    t = (t << 5) - t + i, t = t & t;
  }
  return `user_${Math.abs(t)}`;
}
const u = class u {
  constructor() {
    c(this, "isConfigured", !1);
  }
  static getInstance() {
    return u.instance || (u.instance = new u()), u.instance;
  }
  configure(t) {
    if (this.isConfigured) {
      console.warn("AWS is already configured");
      return;
    }
    this.validateParams(t);
    const n = {
      Auth: {
        Cognito: {
          userPoolId: t.userPoolId,
          userPoolClientId: t.userPoolClientId,
          region: t.region,
          authenticationFlowType: "USER_SRP_AUTH",
          signUpVerificationMethod: "code",
          loginWith: {
            email: !0,
            phone: !1,
            username: !1
          },
          passwordFormat: {
            minLength: 8,
            requireLowercase: !0,
            requireUppercase: !0,
            requireNumbers: !0,
            requireSpecialCharacters: !1
          }
        }
      }
    };
    try {
      k.configure(n), this.isConfigured = !0, console.info("AWS configuration completed successfully");
    } catch (i) {
      throw console.error("Failed to configure AWS:", i), new Error("AWS configuration failed");
    }
  }
  validateParams(t) {
    const n = [];
    if (t.region || n.push("region"), t.userPoolId || n.push("userPoolId"), t.userPoolClientId || n.push("userPoolClientId"), n.length > 0)
      throw new Error(
        `Missing required AWS config parameters: ${n.join(", ")}`
      );
  }
  isAWSConfigured() {
    return this.isConfigured;
  }
};
c(u, "instance");
let w = u;
const ft = w.getInstance();
export {
  Y as AA_THRESHOLD,
  xe as AUTH_ERROR_CODES,
  De as AUTH_FLOW_TYPES,
  Q as AuthErrorMessages,
  O as AuthenticationError,
  ne as ConnectionError,
  Le as DEVICE_KEY_STORAGE,
  He as DEVICE_STORAGE_KEY,
  ze as DEVICE_TRUST_DURATION_DAYS,
  ve as DEVICE_TRUST_KEY,
  d as DateFormats,
  te as ErrorCategory,
  _ as ErrorClassifier,
  ee as ErrorSeverity,
  q as FileKind,
  Ve as MAX_MFA_ATTEMPTS,
  Fe as MFA_CHALLENGE_TYPES,
  $e as MFA_CODE_EXPIRY_MINUTES,
  be as MFA_CODE_LENGTH,
  ke as MFA_RETRY_DELAY_SECONDS,
  We as MFA_SESSION_KEY,
  S as PASSWORD_REQUIREMENTS,
  ct as addApiBreadcrumb,
  at as addAuthBreadcrumb,
  dt as addFileUploadBreadcrumb,
  ot as addFormSubmissionBreadcrumb,
  rt as addNavigationBreadcrumb,
  ut as addUserActionBreadcrumb,
  lt as addValidationErrorBreadcrumb,
  ft as awsConfig,
  mt as captureException,
  ht as captureMessage,
  Je as changePasswordSchema,
  st as clearSentryFormContext,
  je as confirmSignUpSchema,
  tt as createConnectionError,
  pe as dateUtils,
  Ze as enhancedAuthErrorHandler,
  Ke as forgotPasswordSchema,
  he as formAppUrl,
  Ee as formAppUrlBranded,
  f as getCanonicalDomain,
  Me as getDateFnsLocale,
  N as getFileKind,
  Ne as getPreferredDashboardView,
  ie as isConnectionError,
  we as isExternalUrl,
  _e as isImage,
  Se as isPdf,
  Pe as isStorageAvailable,
  p as linearize,
  ge as listingAppUrlBranded,
  fe as listingCheckinUrl,
  P as luminance,
  Qe as newPasswordSchema,
  C as parseHex,
  R as parseLocalDate,
  Re as readStorageJson,
  X as readStorageValue,
  Ce as removeStorageValue,
  Xe as resetPasswordSchema,
  ye as scrollToSection,
  Ae as setPreferredDashboardView,
  it as setSentryFormContext,
  nt as setSentryUserContext,
  qe as signInSchema,
  Ye as signUpSchema,
  Te as soundUtils,
  Ue as typography,
  et as unconfirmedAccountManager,
  Be as useMediaQuery,
  Ge as usePasswordValidator,
  Ie as validateContrast,
  Oe as writeStorageJson,
  j as writeStorageValue
};
